<template>
  <div class="page-container">
    <div class="page-header">
      <picture class="banner-picture">
        <source media="(max-width: 768px)" srcset="/official/assets/static/contents/sitefiles2047/10237182/images/55021386.png" />
        <img class="banner-bg" src="/official/assets/static/contents/sitefiles2047/10237182/images/55021386.png" alt="" />
      </picture>
      <div class="banner-overlay"></div>
      <div class="container">
        <h1>{{ article?.title || '新闻详情' }}</h1>
        <p class="subtitle">
          <span v-if="article">{{ article.category }} · {{ article.date }}</span>
        </p>
      </div>
    </div>

    <div class="container content" v-if="article">
      <div class="breadcrumb">
        <router-link to="/news">新闻资讯</router-link>
        <span class="sep">/</span>
        <span>{{ article.category }}</span>
      </div>

      <div class="detail-wrapper">
        <div class="meta">
          <span class="tag">{{ article.category }}</span>
          <span class="dot">•</span>
          <span>{{ article.date }}</span>
        </div>
        <img v-if="article.cover" class="article-cover" :src="article.cover" :alt="article.title" />
        <div class="detail-content" v-html="article.content"></div>
      </div>
    </div>

    <div class="container content" v-else>
      <div class="not-found">
        <h2>未找到该新闻</h2>
        <router-link class="back" to="/news">返回新闻列表</router-link>
      </div>
    </div>
  </div>
  </template>

<script>
export default {
  props: ['slug'],
  setup(props) {
    const { findArticleBySlug } = require('@/data/news.js')
    const article = findArticleBySlug(props.slug)
    return { article }
  }
}
</script>

<style scoped>
.page-header {
  padding: 0;
  margin-bottom: 40px;
  color: #fff;
  text-align: center;
  position: relative;
  overflow: hidden;
  aspect-ratio: 4 / 1;
  display: flex;
  align-items: center;
}
.banner-picture {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: block;
}
.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: none;
}
.banner-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.08;
  background:
    radial-gradient(650px 360px at 15% 25%, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 62%),
    radial-gradient(620px 360px at 85% 45%, rgba(255, 214, 102, 0.04) 0%, rgba(255, 214, 102, 0) 64%),
    linear-gradient(135deg, rgba(0, 104, 183, 0.40) 0%, rgba(0, 71, 133, 0.34) 100%);
  z-index: 1;
}
.banner-overlay::before {
  content: '';
  position: absolute;
  inset: -25%;
  background:
    radial-gradient(closest-side at 18% 30%, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0)),
    radial-gradient(closest-side at 82% 42%, rgba(255, 189, 92, 0.18), rgba(255, 189, 92, 0)),
    radial-gradient(closest-side at 55% 90%, rgba(160, 132, 255, 0.18), rgba(160, 132, 255, 0));
  filter: blur(22px);
  opacity: 0.9;
  animation: pageBannerBlobs 18s ease-in-out infinite alternate;
}

.banner-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 10px 10px, rgba(255, 255, 255, 0.14) 2px, rgba(255, 255, 255, 0) 3px),
    radial-gradient(circle at 48px 60px, rgba(255, 255, 255, 0.10) 1px, rgba(255, 255, 255, 0) 2px);
  background-size: 70px 70px, 140px 140px;
  opacity: 0.18;
  animation: pageBannerParticles 26s linear infinite;
  pointer-events: none;
}
.page-header .container { display: none; }
.page-header h1 {
  animation: pageFadeUp 700ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.subtitle { margin: 0; opacity: 0.9; animation: pageFadeUp 800ms 120ms cubic-bezier(0.2, 0.8, 0.2, 1) both; }
.container { max-width: 1000px; margin: 0 auto; padding: 0 20px; }
.content { padding-bottom: 80px; }

@media (max-width: 768px) {
  .page-header {
    aspect-ratio: 4 / 5;
  }
}

@keyframes pageFadeUp {
  from { opacity: 0; transform: translate3d(0, 10px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@keyframes pageBannerZoom {
  from { transform: scale(1.06); }
  to { transform: scale(1.12); }
}

@keyframes pageBannerBlobs {
  0% { transform: translate3d(-1%, -1%, 0) scale(1); }
  50% { transform: translate3d(2%, 2%, 0) scale(1.03); }
  100% { transform: translate3d(-2%, 3%, 0) scale(1.02); }
}

@keyframes pageBannerParticles {
  from { background-position: 0 0, 0 0; }
  to { background-position: 0 -420px, 0 -840px; }
}

@media (prefers-reduced-motion: reduce) {
  .banner-bg,
  .banner-overlay::before,
  .banner-overlay::after,
  .page-header h1,
  .subtitle {
    animation: none !important;
  }
}

.breadcrumb {
  margin-bottom: 16px;
  color: #666;
}
.breadcrumb .sep { margin: 0 6px; }
.breadcrumb a { color: #0068b7; text-decoration: none; }

.detail-wrapper {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 30px 26px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.05);
}
.article-cover {
  width: 100%;
  height: clamp(210px, 30vw, 340px);
  object-fit: cover;
  display: block;
  border-radius: 14px;
  margin: 16px 0 18px;
  box-shadow: 0 12px 28px rgba(0,0,0,0.10);
}
.meta { color: #888; margin-bottom: 14px; }
.meta .tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f3ecfb;
  color: #0068b7;
  font-size: 12px;
  margin-right: 10px;
}
.detail-content h3 { margin: 18px 0 10px; color: #333; }
.detail-content p { color: #555; line-height: 1.8; margin: 10px 0; text-align: justify; }
.detail-content ul, .detail-content ol { padding-left: 20px; color: #555; }
.detail-content blockquote {
  border-left: 4px solid #0068b7;
  background: #f8f4fc;
  padding: 10px 14px;
  color: #555;
  border-radius: 6px;
}

.not-found { text-align: center; padding: 40px 0; }
.back {
  display: inline-block;
  margin-top: 10px;
  color: #0068b7;
  text-decoration: none;
}
</style>
